/**
 * @generated SignedSource<<256af91da5653c0599876bc8ad9545e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
import { FragmentRefs } from "relay-runtime";
export type StoreUserRoleAndEmailTag_storeUser$data = {
  readonly role: Roles;
  readonly user: {
    readonly email: string;
  };
  readonly " $fragmentType": "StoreUserRoleAndEmailTag_storeUser";
};
export type StoreUserRoleAndEmailTag_storeUser$key = {
  readonly " $data"?: StoreUserRoleAndEmailTag_storeUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoreUserRoleAndEmailTag_storeUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoreUserRoleAndEmailTag_storeUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoreUser",
  "abstractKey": null
};

(node as any).hash = "da74cd746bf16d486b4205a2e95bace6";

export default node;
